import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class ClassHtmlBridgePrototype extends HtmlBridgePrototype{

    public className:string;
    
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ClassHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class ClassHtmlBridge extends HtmlBridge{
    
    private className:string;
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:ClassHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.className = prototype.className;
    }
    
    public set value(v: boolean) { 
        this._value = v; 
        if(v===true){
            this.element.classList.add(this.className);
        }else{
            this.element.classList.remove(this.className);
        }
    } public get value(): boolean { return this._value;} private _value: boolean;
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }

    public release(){
        this.binding.release();
    }
}